// extracted by mini-css-extract-plugin
export default {"container":"admin_console_container__qIDA6","quotation_container":"admin_console_quotation_container__+CUax","areas_container":"admin_console_areas_container__OwRsW"};